import React from 'react';
import imageApi from '@umu/umu-image-handle';
import { LazyImg, LazyImgProps } from './components/lazyImg';
import { isWebpUrl } from './util';
export { LazyImg } from './components/lazyImg';
export { LazyBgImg } from './components/lazyBgImg';

interface IImgProps extends LazyImgProps {
    lazy?: boolean;
    width?: number;
    disableWebp?: boolean;
}

/**
 * Img 组件。默认 lazy; 默认 webp
 */
export const Img = (props: IImgProps) => {
    const { width, lazy = true, disableWebp = false } = props;

    let src = props.src;
    let webpSrc = '';
    if (imageApi.isFromCDN(props.src)) {
        src = width ? imageApi.appendWidth(src, width) : src;
        webpSrc = disableWebp || isWebpUrl(src) ? '' : imageApi.convertFormat(src, 'webp');
    }

    if (lazy) {
        return <LazyImg {...props} src={src} webpSrc={webpSrc} />;
    }

    return (
        <picture>
            {webpSrc ? <source srcSet={webpSrc} type="image/webp" /> : null}
            <img {...props} src={src} />
        </picture>
    );
};
